import type { CapabilityMode } from "@/api/admin/delegation"

type Inputs = {
  isPlatformAdmin: boolean
  userModes: Record<string, string> | undefined
  previewModes: Record<string, CapabilityMode> | undefined
  previewingCustomer: boolean
}

/** Settings are unrestricted only for a real platform admin outside preview. */
export function resolveManagementCapabilityModes({
  isPlatformAdmin,
  userModes,
  previewModes,
  previewingCustomer,
}: Inputs): Record<string, CapabilityMode> | undefined {
  if (previewingCustomer) return previewModes ?? {}
  if (isPlatformAdmin) return undefined

  // A real delegated admin must use the same fail-closed registry filter as
  // platform-admin preview. An absent/unknown mode never becomes a grant.
  const resolved: Record<string, CapabilityMode> = {}
  for (const [key, mode] of Object.entries(userModes ?? {})) {
    if (mode === "manage" || mode === "available" || mode === "hidden") {
      resolved[key] = mode
    }
  }
  return resolved
}
